// The session this browser is holding, as one store every document reads from.
//
// localStorage is the backing store and the source of truth; the snapshot in front of it exists
// for useSyncExternalStore, which compares snapshots by identity — a fresh object every read is a
// store that has always just changed, and a render loop rather than a re-render.
const SESSION_KEYS = ['authToken', 'refreshToken']
const listeners = new Set()

const readLocal = () => SESSION_KEYS.reduce((session, key) => ({
  ...session,
  [key]: typeof localStorage !== 'undefined' ? localStorage.getItem(key) : null
}), {})

let snapshot = readLocal()

const publishIfChanged = next => {
  if (SESSION_KEYS.every(key => next[key] === snapshot[key])) return

  snapshot = next
  listeners.forEach(listener => listener())
}

export const getItem = key => localStorage.getItem(key)

export const setItem = (key, value) => {
  localStorage.setItem(key, value)
  publishIfChanged({...snapshot, [key]: value})
}

export const removeItem = key => {
  localStorage.removeItem(key)
  publishIfChanged({...snapshot, [key]: null})
}

export const setAuthToken = token => setItem('authToken', token)

export const subscribe = listener => {
  listeners.add(listener)

  return () => listeners.delete(listener)
}

export const getSnapshot = () => snapshot

// Another tab signing in or out writes the same storage, and the window storage event is how this
// one hears about it — it fires in every document but the writer.
if (typeof window !== 'undefined')
  window.addEventListener('storage', () => publishIfChanged(readLocal()))
